<template>
    <div class="store-locator__map__open-street-map" ref="open-street-map"></div>
</template>

<script>
    import {createScript, loadScripts, createStyle} from '../helpers/loader';
    import template from '../helpers/template';

    let loading = false;

    const DEFAULTS = {
        callback: '__google_maps_api_provider__',       //
        key: null,                                      // Api key
        libraries: [],                                  // ['geometry', 'places']
        client: null,                                   // 'yourclientkey'
        version: '3.18',                                // '3.18'
        channel: null,                                  //
        language: null,                                 // 'fr'
        region: null                                    // 'GB'
    };

    export default {
        name: "cp-open-street-map",
        props: {
            options: {
                required: true,
                type: Object,
            },
            stores: {
                required: true,
                type: Array,
            },
        },
        data() {
            return {
                circle: null,
                clusters: null,
                infoWindows: {},
                location: null,
                map: null,
                markers: [],
            };
        },
        watch: {
            /**
             * @param stores
             */
            stores(stores) {
                this.createMarkers(stores);

                if (this.clusters) {
                    this.createClusters();
                }
            },
        },
        methods: {
            /**
             * Active a marker and open his info window.
             * @param uid
             */
            activeMarker(uid) {

            },

            /**
             * Center map to the given lat, lng and set the zoom level.
             * @param lat
             * @param lng
             * @param zoom
             */
            centerMap(lat, lng, zoom = null) {

            },

            /**
             * If exists, remove the radius circle from the map.
             */
            clearCircle() {

            },

            /**
             * If exists, remove all clusters from the map.
             */
            clearClusters() {

            },

            /**
             * If exists, remove the current location marker from the map.
             */
            clearCurrentMarker() {

            },

            /**
             * Remove all markers from the map.
             * @param remove
             */
            clearMarkers(remove = false) {

            },

            /**
             * Create a circle radius on the given lat, lng with the given radius.
             * @param lat
             * @param lng
             * @param radius
             */
            createCircle(lat, lng, radius = 5000) {

            },

            /**
             * Create clusters on the map.
             */
            createClusters() {

            },

            /**
             * Create a current location marker on given lat, lng.
             * @param lat
             * @param lng
             */
            createCurrentMarker(lat, lng) {

            },

            /**
             * Instantiate the map.
             */
            createMap() {
                if (this.map) {
                    return;
                }

                this.map = window.L.map(this.$refs['open-street-map']);
            },

            /**
             * Create a marker on the given lat, lng.
             * @param lat
             * @param lng
             * @param options
             * @return
             */
            createMarker(lat, lng, options = {}) {

            },

            /**
             * Create all markers from the given stores.
             * @param stores
             */
            createMarkers(stores) {

            },

            /**
             * Display only markers inside a radius starting on the given lat, lng with a radius of the given distance.
             * @param lat
             * @param lng
             * @param distance
             */
            displayMarkers(lat, lng, distance = 5000) {

            },

            /**
             * Geolocate user on load.
             */
            geolocateCenter() {

            },

            /**
             * Load Google Maps Api and dependencies
             * @param options
             */
            loadOpenStreetMapApi(options) {
                if (window.L) {
                    return window.L;
                }

                this.$action.loading(true);

                new Promise((resolve, reject) => {
                    if (window.L) {
                        resolve(window.L);
                    } else if (loading) {
                        let interval = setInterval( () => {
                            if (window.L) {
                                interval && clearInterval(interval);

                                loading = false;
                                resolve(window.L);
                            }
                        }, 10);
                    } else {
                        loading = false;

                        resolve(window.L);

                        const style_url = 'https://unpkg.com/leaflet@1.3.1/dist/leaflet.css';
                        const script_url = 'https://unpkg.com/leaflet@1.3.1/dist/leaflet.js';

                        createStyle(style_url, null, reject);
                        createScript(script_url, null, reject);
                    }
                })
                .then( (L) => {
                    loadScripts(this.getConfig('dependencies'), () => {
                        this.$bus.emit('api-loaded', L);
                        this.$action.loading(false);
                    });
                });
            },
        },
        mounted() {
            this.trace('{open-street-map.vue} mounted');

            // this.$bus.on('disable-marker', () => this.map.infoWindow.close());
            // this.$bus.on('active-marker', (uid) => this.activeMarker(uid));
            // this.$bus.on('center-map', (lat, lng, zoom) => this.centerMap(lat, lng, zoom));
            // this.$bus.on('clear-circle', () => this.clearCircle());
            // this.$bus.on('clear-current-marker', () => this.clearCurrentMarker());
            // this.$bus.on('create-circle', (lat, lng, radius) => this.createCircle(lat, lng, radius));
            // this.$bus.on('create-current-marker', (lat, lng, options) => this.createCurrentMarker(lat, lng, options));
            // this.$bus.on('display-markers', (lat, lng, distance) => this.displayMarkers(lat, lng, distance));

            this.$bus.on('api-loaded', () => {
                this.createMap();
                // this.createMarkers(this.stores);
                //
                // if (this.options.clusters) {
                //     this.createClusters();
                // }
                //
                // if (this.options.geocode) {
                //     this.geolocateCenter();
                // }
            });

            this.loadOpenStreetMapApi(this.getConfig('api'));
        },
    }
</script>
